import React, { useContext } from 'react'
import { voiceCallActionExecutionData } from '../../../../../models/axiosModel';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { Grid, Typography } from '@mui/material';
import IconsColor from '../../../../../components/utility/iconsColor';
import { whiteColor } from '../../../../../utils/colors';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { VOICE_CALL_STATUS_LABEL } from '../../../constants';
import { renderMediaMsg } from '../../../renderUtils';
import { getMediaUrl } from '../../../utils';

interface VoiceCallActionProps {
    actionData: voiceCallActionExecutionData
} 

const VoiceCallAction: React.FC<VoiceCallActionProps> = (props) => {

    const { actionData } = props;
    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const isInComingVoiceCall = () => {
        return actionData?.flag_voice_direction_inbound;
    }

    const getVoiceCallStatus = () => {
        const status = actionData?.whatsapp_call_status_name;
        return VOICE_CALL_STATUS_LABEL[status ?? ''] ?? '';    
    }

    return (
        <>
            <Grid item className={styles.voiceCallActionMainGrid}>
                <Grid container direction={"column"} gap={1}>
                    <Grid item>
                        <Grid container className={`${globalStyles.displayFlexStyle} ${styles.voiceCallInfoGrid}`}>
                            <Grid item className={styles.voiceCallInfoIconGrid}>
                                {isInComingVoiceCall() ?
                                    <IconsColor iconName="inComingVoiceCall" height="20px" width="20px" fillColor={whiteColor} />
                                    :
                                    <IconsColor iconName="outGoingVoiceCall" height="20px" width="20px" fillColor={whiteColor} />
                                }
                            </Grid>
                            <Grid item>
                                <Grid container direction={"column"}>
                                    <Grid item>
                                        <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                            Voice Call
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={`${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight} ${styles.voiceCallStatus}`}>
                                            {getVoiceCallStatus()}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {actionData?.recording && 
                        <Grid item>
                            {renderMediaMsg('audio', getMediaUrl(vendorData, actionData?.recording?.google_storage_id), "", actionData?.recording?.file_name)}
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default VoiceCallAction
